'use strict';

module.exports = function ( config ) {
    config = config || {};

    /**
     * Is epg can be downloaded.
     */
    this.downloadable = false;

    /**
     * Start time ms.
     */
    this.start = config.start;

    /**
     * End time ms.
     */
    this.end = config.start + config.duration;

    /**
     * Epg title.
     */
    this.title = config.name;

    this.id = null;

    /**
     * Is epg in archive.
     */
    this.archive = false;

    /**
     * Link to channel.
     */
    this.channel = config.channel;

    this.info = config.info;
    this.duration = config.duration;
    this.details = config.details;
};
